import { BaseRecord } from '@/models/games/BaseRecord';
import {
    RouletteBigSmall,
    RouletteColor,
    RouletteOddEven,
} from '@/models/games/roulette/Record';
import { convertStringToResult } from '@/models/games/ultraRoulette/GameResult';
import { UltraRouletteResult } from '@/models/games/ultraRoulette/Result';
import { SupportedGameResult } from '@/modules/host/models';
import {
    getWinBetType,
    resultToBigSmall,
    resultToColor,
    resultToOddEven,
} from './roulette';

export type UltraRouletteRecord = BaseRecord & OwnRecord;
export type OwnRecord = {
    color?: RouletteColor;
    oddEven?: RouletteOddEven;
    bigSmall?: RouletteBigSmall;
    resultMultipier: number;
};

export const convertResultToRecord = (
    result: UltraRouletteResult
): UltraRouletteRecord => {
    const winBetList = getWinBetType(result.Result);
    const record: UltraRouletteRecord = {
        gameID: result.GameID,
        result: result.Result,
        round: result.GameCount % 10000,
        shoes: Math.floor(result.GameCount),
        winBetType: winBetList,
        resultPoint: result.ResultPoint,
        color: resultToColor(result.Result, result.ResultPoint),
        oddEven: resultToOddEven(result.Result),
        bigSmall: resultToBigSmall(result.Result),
        resultMultipier: result.ResultMultipier,
    };

    return record;
};

export const convertResultStringToRecord = (
    currentResult: SupportedGameResult,
    resultString: string,
    result?: number
): UltraRouletteRecord => {
    const { FResult, GameID, Result, GameCount } = currentResult;
    const gameResult = resultString
        ? convertStringToResult(resultString)
        : convertStringToResult('{"R":255,"RM":0,"MS":0,"M":[]}}');
    const updateResult: UltraRouletteResult = {
        FResult: FResult,
        GameCount: GameCount,
        GameID: GameID,
        Result: result ?? Result,
        ResultPoint: gameResult.ResultPoint,
        ResultMultipier: gameResult.ResultMultipier,
        Multipier: gameResult.Multipier,
        Multipiers: gameResult.Multipiers,
    };

    const resultRecord = convertResultToRecord(updateResult);
    return resultRecord;
};
